import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TaskService} from '../../services/task.service';

@Component({
  selector: 'nf-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  @Input() smsPattern = 'custom';
  @Input() columnEnable = true;
  @Input() updateEnable = false;
  @Input() boardData;
  @Input('boardColumnData') set boardColumnDataChange(data) {
    if (data) {
      this.boardColumnData = data;
      let index = this.boardColumnData.findIndex(item => item.id === 'update');
      if (index < 0) {
        this.boardColumnData.push({
          id: 'update',
          title: '更新'
        });
      }
    }
  }
  boardColumnData = [];
  @Input('smsTemplateList') set templateListDataChange(data) {
    if (data) {
      this.smsTemplateList = data;
      this.smsTemplate = this.smsTemplateList[0];
      this.smsTemplateChange();
    }
  }
  @Input('nfData') set componentDataChange(data) {
    if (data) {
      let columnMap = {};
      for (let column of this.boardColumnData) {
        columnMap[column.id] = column;
      }
      // 初始化数据
      if (data.hasOwnProperty('subject')) { // 通知类型为邮件
        this.notificationType = 'email';
        if (data.subject) {
          this.subject = this.initLabels(data.subject, this.subjectLabels, columnMap);
        }
        if (data.body) {
          this.body = this.initLabels(data.body, this.bodyLabels, columnMap);
        }
        this.cc = data.cc || {};
      } else if (data.hasOwnProperty('title')) { // 通知类型为站内信
        this.notificationType = 'siteMessage';
        if (data.title) {
          this.subject = this.initLabels(data.title, this.subjectLabels, columnMap);
        }
        if (data.content) {
          this.body = this.initLabels(data.content, this.bodyLabels, columnMap);
        }
      } else { // 通知类型为短信
        this.notificationType = 'sms';
        if (this.smsPattern === 'custom') { // 自定义短信内容
          if (data.content) {
            this.body = this.initLabels(data.content, this.bodyLabels, columnMap);
          }
        } else { // 使用模板
          if (data.templateCode) {
            for (const template of this.smsTemplateList) {
              if (template.content.templateCode === data.templateCode) {
                this.smsTemplate = template;
                break;
              }
            }
            this.smsTemplateChange();
            if (this.smsTemplate.content.params) {
              for (let i = 0; i < this.smsTemplate.content.params.length; i++) {
                const key = this.smsTemplate.content.params[i].code;
                this.params[i] = this.initLabels(data.params[key], this.paramLabels[i], columnMap);
              }
            }
          }
        }
      }
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  subject;
  body;
  cc = {};
  subjectLabels = [];
  bodyLabels = [];
  paramLabels = [];
  focusOn;
  selectionStart = 1;
  notificationType = 'email';
  subjectPlaceholder = '请输入邮件主题';
  bodyPlaceholder = '请输入邮件内容';
  smsTemplateList = [];
  smsTemplate: any = {};
  params = [];

  constructor() { }

  ngOnInit() {
  }

  initLabels(target, targetArray, columnMap) {
    if (target) {
      target = target.replace(/pulse\./g, '');
      let labels = target.match(/\{[^\{\}]+\}/g);
      if (labels) {
        for (let label of labels) {
          label = label.replace('\{', '').replace('\}', '');
          if (columnMap[label]) {
            targetArray.push(columnMap[label]);
            target = target.replace(label, columnMap[label]['title']);
          }
        }
      }
    }
    return target;
  }

  getUserData(data) {
    this.cc = data;
  }

  notificationTypeChange() {
    if (this.notificationType === 'email') {
      this.subjectPlaceholder = '请输入邮件主题';
      this.bodyPlaceholder = '请输入邮件内容';
    } else if (this.notificationType === 'siteMessage') {
      this.subjectPlaceholder = '请输入主题';
      this.bodyPlaceholder = '请输入内容';
    } else {
      this.bodyPlaceholder = '请输入内容';
    }
  }

  getInputIndex(target) {
    setTimeout(() => {
      this.selectionStart = target.selectionStart;
    }, 50);
  }

  focusOnTarget(target) {
    this.focusOn = target;
  }

  inputValueChange() {
    switch (this.focusOn) {
      case 'subject':
        this.handleLabelChange(this.subject, this.subjectLabels);
        break;
      case 'body':
        this.handleLabelChange(this.body, this.bodyLabels);
        break;
      default:
        this.handleLabelChange(this.params[this.focusOn], this.paramLabels[this.focusOn]);
        break;
    }
  }

  handleLabelChange(target, targetArray) {
    let regexp = /\{[^\{\}]+\}/g;
    if (target) {
      setTimeout(() => {
        const preValue = target.substring(0, this.selectionStart);
        const afterValue = target.substring(this.selectionStart, target.length);
        const preCount = preValue && preValue.match(regexp)? preValue.match(regexp).length: 0;
        const afterCount = afterValue && afterValue.match(regexp)? afterValue.match(regexp).length: 0;
        const sum = preCount + afterCount;
        if (sum < targetArray.length) {
          targetArray.splice(preCount, targetArray.length - sum);
        }
      }, 100);
    } else {
      targetArray = [];
    }
  }

  smsTemplateChange() {
    this.paramLabels = [];
    if (this.smsTemplate.content && this.smsTemplate.content.params) {
      for (let i = 0; i < this.smsTemplate.content.params.length; i++) {
        this.paramLabels.push([]);
      }
    }
  }

  updateClick() {
    const column = {id: 'update', title: '更新'};
    this.insertLabel(this.body, this.bodyLabels, column);
    this.body = this.assembleStr(this.body, column, 'title');
    this.selectionStart += '{update}'.length;
  }

  columnTagClick(column) {
    if (this.focusOn !== null && this.focusOn !== undefined) {
      switch (this.focusOn) {
        case 'subject':
          this.insertLabel(this.subject, this.subjectLabels, column);
          this.subject = this.assembleStr(this.subject, column, 'title');
          break;
        case 'body':
          this.insertLabel(this.body, this.bodyLabels, column);
          this.body = this.assembleStr(this.body, column, 'title');
          break;
        default:
          this.insertLabel(this.params[this.focusOn], this.paramLabels[this.focusOn], column);
          this.params[this.focusOn] = this.assembleStr(this.params[this.focusOn], column, 'title');
          break;
      }
      this.selectionStart += ('{' + column.title + '}').length;
    }
  }

  insertLabel(target, targetArr, column) {
    if (this.selectionStart > 1) {
      const labels = [];
      for (let item of targetArr) {
        labels.push(item.title);
      }
      target = target || '';
      const matchArray = target.substring(0, this.selectionStart).match(/\{[^\{\}]+\}/g);
      let count = 0;
      if (matchArray) {
        count = matchArray.length;
        for (let i = 0; i < matchArray.length; i++) {
          if (i > labels.length || !matchArray[i].includes(labels[i])) {
            count--;
          }
        }
      }
      targetArr.splice(count, 0, column);
    } else {
      targetArr.splice(0, 0, column);
    }
  }

  assembleStr(target, column, attr) {
    if (target) {
      target = target.substring(0, this.selectionStart)
        + '{' + column[attr] + '}' + target.substring(this.selectionStart, target.length);
    } else {
      target = '{' + column[attr] + '}';
    }
    return target;
  }

  submitData() {
    let pattern = /\{(?!pulse)[^\{\}]+\}/;
    const data = {
      type: this.notificationType,
      content: null
    };
    // 处理主题中包含的标签
    if (this.subjectLabels.length > 0) {
      let subject = this.subject;
      for (let label of this.subjectLabels) {
        subject = subject.replace(pattern, ('{pulse.' + label.id + '}'));
      }
      this.subject = subject;
    }
    // 处理内容中包含的标签
    if (this.bodyLabels.length > 0) {
      let body = this.body;
      for (let label of this.bodyLabels) {
        body = body.replace(pattern, ('{pulse.' + label.id + '}'));
      }
      this.body = body;
    }
    let params = {};
    // 处理短信模板参数中的标签
    if (this.paramLabels.length > 0) {
      for (let i = 0; i < this.paramLabels.length; i++) {
        let val = this.params[i];
        for (let label of this.paramLabels[i]) {
          val = val.replace(pattern, ('{pulse.' + label.id + '}'));
        }
        params[this.smsTemplate.content.params[i]['code']] = val;
      }
    }
    // 设置返回数据结构和内容
    if (this.notificationType === 'email') {
      data.content = {
        subject: this.subject,
        cc: this.cc,
        body: this.body
      };
    } else if (this.notificationType === 'siteMessage') {
      data.content = {
        title: this.subject,
        content: this.body
      };
    } else {
      if (this.smsPattern === 'template') {
        data.content = {
          templateCode: this.smsTemplate.content.templateCode,
          params: params
        }
      } else {
        data.content = {
          content: this.body
        }
      }
    }
    this.nfDataChange.emit(data);
  }
}
